import {cva} from 'cva';

export const FieldClassName = cva('~Field__input', {
    variants: {
        height: {
            default: '',
            unset: '~Field__input--unsetHeight',
        },
    },
    defaultVariants: {
        height: 'default',
    },
});
